module.exports = {
	"en": {
		"models": {
			"duplicate_action": "Duplicate",
			"edit_action": "Edit",
			"delete_action": "Delete",
			"add_to_project": {
				"select": "Select Project"
			},
			"select_type": {
				"title_h1": "H1 title",
				"title_h2": "H2 title",
				"title_h3": "H3 title",
				"title_h4": "H4 title",
				"image": "Image",
				"paragraph": "Paragraph",
				"hidden": "Hidden field",
				"text": "Text field",
				"textarea": "Textarea",
				"select": "Select field",
				"radio": "Radio field",
				"radio_custom": "Radio custom field",
				"checkbox": "Checkbox field",
				"checkbox_custom": "Checkbox custom field",
				"country_select": "Country select field",
				"confirmation": "Confirmation field",
				"free_drawing": "Free drawing",
				"submit": "Submit",
				"container": "Container",
				"container_grid": "Grid container",
				"container_top": "Container top",
				"container_bottom": "Container bottom",
				"container_tab": "Container tab",
				"crawled_infos": "Crawled info",
				"read_only": "Read only"
			},
			"select_role": {
				"user": "Standard user",
				"admin": "Administrator"
			},
			"select_status": {
				"pre_review": "Pre Revision",
				"review": "Needs revision",
				"active": "Accepted"
			},
			"select_frequency": {
				"daily": "Daily",
				"immediately": "Every hour",
				"once": "Only once"
			},
			"select_scope": {
				"organization": "Organization",
				"project": "Project"
			},
			"auth": {
				"remember_me": "Stay logged 7 days"
			},
			"business_kit": {
				"action": "",
				"date": "Date",
				"fail": "The sending of the Businesskit failed",
				"id": "id",
				"name": "Name",
				"select": "BusinessKit",
				"sent": "Your Businesskit has been sent",
				"create_template": "Create template",
				"status": {
					"email_sent": "Sent",
					"sendout_enqueued": "Sent",
					"transferred": "Transferred"
				},
				"missing": {
					"email": "Sending failed. You probably have to create an email template before sending the Businesskit."
				}
			},
			"external_form": {
				"action": "Actions",
				"additional_data": "Additional data",
				"configuration": "Configuration",
				"email_recipient_address": "Send to",
				"id": "#",
				"language": "Language",
				"message": {
					"create": "The form has been added successfully",
					"update": "The form has been updated successfully"
				},
				"name": "Name",
				"project_id": "Project",
				"project_name": "Project",
				"project__name": "Project",
				"slug": "ID",
				"structure": "Structure",
				"duplicate": "",
				"duplicate_desc": "Duplicate the form",
				"duplicate_project_desc": "Duplicate the project",
				"title": "Form title"
			},
			"email_template": {
				"id": "",
				"name": "Name",
				"language": "Language",
				"duplicate": "",
				"action": "Actions",
				"organization": "Organization",
				"body": "Email content",
				"salutation": "Salutation",
				"salutation_fallback": "Fallback salutation",
				"from": "Email from",
				"reply_to": "Reply to",
				"imprint_url": "Imprint url",
				"privacy_url": "Privacy url",
				"primary_color": "Primary color",
				"message": {
					"create": "The email template was successfully created.",
					"update": "The email template was successfully updated."
				},
				"duplicate_desc": "Duplicate email template"
			},
			"lead_mask": {
				"action": "Actions",
				"default": "Default mask ?",
				"yes": "Yes",
				"no": "No",
				"id": "#",
				"language": "Language",
				"message": {
					"create": "The lead sheet was successfully created.",
					"update": "The lead sheet was successfully updated."
				},
				"name": "Name",
				"project_id": "Project",
				"organization": "Organization",
				"organization_name": "Organization",
				"project": "Project",
				"slug": "Slug",
				"structure": "Structure",
				"duplicate": "",
				"duplicate_desc": "Duplicate lead sheet"
			},
			"opt-in": {
				"businesskit__name": "Businesskit name",
				"id": "#",
				"project__name": "Project name",
				"subdomain": "Subdomain",
				"template_name": "Template name"
			},
			"organization": {
				"action": "",
				"action_delete": "",
				"city": "City",
				"country": "Country",
				"id": "Id",
				"message": {
					"create": "The organization has been added successfully",
					"update": "The organization has been updated successfully"
				},
				"name": "Name",
				"status": "",
				"street": "Street",
				"street_number": "Street number",
				"users__count": "Users",
				"website": "Website",
				"zip": "Zip code"
			},
			"organization_configuration": {
				"api_token_eventbaxx": "Eventbaxx api token",
				"enrichment_disabled": "Clearbit enrichment",
				"mailchimp_api_key": "Mailchimp api key",
				"ranking_display": "Display the lead hunter rankings?",
				"xing_consumer_key": "Xing consumer key",
				"eventbaxx_auth_token": "Eventbaxx authentication key"
			},
			"organizations": {
				"successfully_started_crm_sync": "CRM synchronisation successfully started"
			},
			"project": {
				"action": "Actions",
				"background_xml_export_enabled": "Enable Leads app synchronisation",
				"base_score": "Base score",
				"scope_leads": "Users can only view their own leads",
				"business_kits_count": "Businesskits",
				"businesskit_to_assign": "Assign a Businesskit",
				"category": "Category",
				"crm_campaign_id": "CRM campaign ID",
				"crm_sales_employee_id": "CRM sales employee ID",
				"crm_marketing_employee_id": "CRM marketing employee ID",
				"crm_group_code_id": "CRM group code foreign ID",
				"enable_lead_review": "Enable manual lead review from the Leads app",
				"end_date": "Campaign end date",
				"hot_leads_count": "Hot leads",
				"id": "#",
				"is_opt_in": "Is opt-in?",
				"lead_mask": "Lead sheet",
				"lead_mask_id": "Select an existing lead sheet",
				"leads_count": "Leads",
				"product": "Product",
				"leads_not_synced_count": "Pending leads",
				"location": "Location",
				"mailchimp_list_id": "Mailchimp list ID",
				"message": {
					"create": "The project has been added successfully",
					"update": "The project has been updated successfully"
				},
				"name": "Name",
				"organization": "Organization",
				"organization_name": "Organization",
				"organization_id": "Organization",
				"period": "Period",
				"set_aditional_data_content": "Show and set additional data",
				"start_date": "Campaign start date",
				"sync_disabled": "CRM synchronisation",
				"unsynced_leads_count": "Sync status",
				"unsynced_leads_count_success": "Synced",
				"user_to_assign": "Assign a user",
				"duplicate": "",
				"default_classification": "Default classification",
				"business_kit_id": "Businesskits",
				"project_label": "Project labels"
			},
			"project_lead": {
				"academic_title": "Title",
				"action": "Actions",
				"advancement": "Advancement",
				"branch": "Industry",
				"business_card_job_title": "Job title",
				"capturer": "Capturer",
				"capturer_unknown": "Unassigned",
				"city": "City",
				"classification": "Classification",
				"company": "Company",
				"company-name": "Company name",
				"company_department": "Department",
				"company_function": "Function",
				"company_role": "Role",
				"company_website": "Company website",
				"conversation_notes": "Notes",
				"country": "Country",
				"crawled_infos": {
					"by": "by",
					"category": "Categories",
					"description": "Description",
					"domain": "Website",
					"emailAddresses": "Emails",
					"foundedYear": "Founded",
					"linkedin": "Linkedin profile",
					"location": "Location",
					"metrics": "Metrics",
					"more_infos": "More information",
					"name": "Company name",
					"phoneNumbers": "Phone numbers",
					"phone_number": "Phone given in the web",
					"tags": "Tags",
					"title_website": "Title of the website",
					"tweets": "Tweets",
					"founded": ""
				},
				"found_existing": "We found some existing data for this lead and have applied it automatically.",
				"predicted_name": "We have automatically filled in some of your lead's data based on their email address.",
				"created": "Lead was successfully created.",
				"created_at": "Created",
				"email": "Email",
				"exhibition_visitor_count": "Exhibition visitor count",
				"firstname": "Firstname",
				"full_street": "Street & No.",
				"gender": "Gender",
				"id": "#",
				"import_origin": "",
				"import_origins": {
					"crm": "Imported from CRM"
				},
				"interested_in": "Interested in",
				"kit_status": "",
				"language": "Language",
				"lastname": "Lastname",
				"message": {
					"changes_pending": "There are pending changes. Last saved",
					"changes_saved": "Last changes:",
					"create": "The lead has been added successfully",
					"create_from_card": "Scan business card",
					"create_from_email": "Enter email address",
					"leads_exists": "The lead exists already but it has been added to the current project",
					"no_business_card": "No business card uploaded yet",
					"update": "The lead was been updated successfully"
				},
				"name": "Name",
				"origin": "",
				"origins": {
					"mobile_app": "Lead captured via mobile app",
					"web_app": "Lead captured via web app"
				},
				"phone_company": "Company phone",
				"phone_mobile": "Mobile phone",
				"progress_complete": "All required fields have been filled",
				"progress_indicator_businesskit": "Progress",
				"progress_indicator_crm": "Progress",
				"progress_indicator_lead_mask": "Progress",
				"project_planned": "Project planned",
				"salutation": "Salutation",
				"start_date": "Created on",
				"status": "Status",
				"street": "Street",
				"street_number": "Number",
				"sync_disabled": "CRM sync",
				"sync_missing_fields": "Incomplete fields:",
				"sync_status": "CRM",
				"sync_statuses": {
					"no_crm": "No CRM configured",
					"no_crm_desc": "The organization doesn't have a CRM configured",
					"not_sync_ready": "Not ready",
					"not_sync_ready_desc": "The lead misses some fields required for CRM sync",
					"not_synced": "Unsynced",
					"not_synced_desc": "The lead has been imported from CRM but has not been modified",
					"null": "–",
					"processing": "Syncing",
					"processing_desc": "The lead is syncing right now",
					"sync_disabled": "Disabled",
					"sync_disabled_desc": "The lead is ready to be synchronized but the lead sync is disabled",
					"sync_error": "Error",
					"sync_error_desc": "The lead sync produced an error",
					"sync_ready": "Ready",
					"sync_ready_desc": "The lead is ready to be synchronized",
					"synced": "Synced",
					"synced_desc": "The lead has been synced"
				},
				"title": "Title",
				"updated_at": "Last updated",
				"user_id": "Lead detector",
				"zip": "ZIP"
			},
			"select_academic_title": {
				"ba": "Ba",
				"dr": "Dr",
				"mba": "MBA",
				"phd": "PhD",
				"prof": "Prof.",
				"prof_dr": "Prof. Dr."
			},
			"select_background_xml_export_enabled": {
				"false": "No",
				"no": "No",
				"true": "Yes",
				"yes": "Yes"
			},
			"select_branch": {
				"automotive": "Automotive",
				"culture": "Culture",
				"education": "Education",
				"electronics": "Electronics",
				"event": "Event",
				"finance": "Finance",
				"food": "Food / Gastro",
				"health": "Health",
				"import": "Import",
				"insurance": "Insurances",
				"it": "IT",
				"law": "Law",
				"marketing": "Marketing",
				"non_profit": "Non profit",
				"other": "Other",
				"print": "Print",
				"public": "Public",
				"real_estate": "Real estate",
				"service": "Service"
			},
			"select_category": {
				"exhibition": "Exhibition",
				"inbound": "Inbound",
				"other": "Other"
			},
			"select_classification": {
				"cold": "Cold",
				"hot": "Hot",
				"warm": "Warm",
				"unclassified": "–"
			},
			"select_default_classification": {
				"cold": "Cold",
				"hot": "Hot",
				"warm": "Warm",
				"unclassified": "–"
			},
			"select_company_department": {
				"finance": "Finance",
				"human_resources": "Human Resources",
				"it": "IT",
				"marketing": "Marketing",
				"other": "Other",
				"sales": "Sales",
				"secretariat": "Secretariat",
				"service_management": "Service Management"
			},
			"select_company_function": {
				"CEO": "CEO",
				"consultant": "Consultant",
				"head_of": "Head of department",
				"manager": "Manager",
				"managing_director": "Managing director",
				"other": "Other",
				"person_in_charge": "Person in charge"
			},
			"select_company_role": {
				"decision_maker": "Decision maker",
				"decision_maker_budget": "Decision maker with budget",
				"non_decision_maker": "Non decision maker",
				"other": "Other"
			},
			"select_gender": {
				"female": "Female",
				"male": "Male",
				"undefined": "-"
			},
			"select_importOrigin": {
				"crm": "CRM",
				"xls": "XLS"
			},
			"select_interested_in": {
				"meeting": "Meeting",
				"other": "Other",
				"presentation": "Presentation",
				"pricing": "Pricing",
				"product_informations": "Product information"
			},
			"select_is_opt_in": {
				"false": "No",
				"no": "No",
				"true": "Yes",
				"yes": "Yes"
			},
			"select_language": {
				"de": "German",
				"en": "English"
			},
			"select_origin": {
				"mobile_app": "Lead app",
				"opt_in_email": "Opt-in email",
				"opt_in_linked_in": "Opt-in linkedin",
				"opt_in_xing": "Opt-in xing",
				"web_app": "Cloud",
				"external_form": "External Form"
			},
			"select_project_planned": {
				"0-3months": "0-3 months",
				"3-6months": "3-6 months",
				"6-12months": "6-12 months",
				"no_plan": "No plan"
			},
			"select_sync_disabled": {
				"false": "Activated",
				"no": "Activated",
				"true": "Deactivated",
				"yes": "Deactivated"
			},
			"select_sync_status": {
				"no_crm": "No CRM configured",
				"not_sync_ready": "Not 100%",
				"not_synced": "Not edited",
				"processing": "Started",
				"sync_error": "Error",
				"sync_ready": "100%",
				"synced": "Successful"
			},
			"tracking": {
				"activity": "Action",
				"date": "Date",
				"kit": "Kit",
				"specific": {
					"confirm_redeem_coupon": "Click on redeem button",
					"click_event_pdf": "Click Businesskit PDF",
					"cta_coupon": "Click on content CTA",
					"embed_visit_url": "Website URL tracking",
					"open_bag": "Businesskit opened",
					"view_coupon": "Content viewed",
					"view_website": "Clicked on CTA",
					"view_website_coupon": "Clicked on 'visit website'",
					"visit_website": "Website visited",
					"toggle_event_info": "Click Businesskit more information"
				}
			},
			"plan": {
				"id": "ID",
				"name": "Name",
				"price": "Price",
				"organizations_count": "Organizations",
				"action": "Actions",
				"max_users": "Maximum users",
				"message": {
					"update": "Plan successfully updated"
				},
				"max_admins": "Maximum admins",
				"max_businesskits": "Maximum Businesskits",
				"allowed_forms": "Allowed form usage",
				"allowed_statistics": "Allowed statistics usage",
				"allowed_custom_leadsheets": "Allowed custom leadsheets",
				"allowed_email_templates": "Allowed custom email templates",
				"allowed_clearbit": "Allowed Clearbit usage",
				"allowed_crm": "Allowed CRM usage",
				"allowed_api": "Allowed API usage",
				"allowed_eb_whitelabel": "Allowed custom eventbaxx whitelabel",
				"allowed_lead_pdf_download": "Allowed PDF Download for leads"
			},
			"user": {
				"action": "Actions",
				"created_at": "Date",
				"email": "Email",
				"invite-role": "Role",
				"firstname": "First Name",
				"id": "id",
				"lastname": "Last Name",
				"fullname": "Full Name",
				"edit_user": "Edit user",
				"role": "Role",
				"has_valid_email": "validation",
				"message": {
					"create": "The user has been added successfully",
					"update": "The user has been updated successfully"
				},
				"name": "Name",
				"organization": "Organization",
				"organization_id": "Organization",
				"organization_name": "Organization",
				"password": "Password",
				"status": "Status",
				"statuses": {
					"active": "Accepted",
					"confirmed": "Confirmed",
					"inactive": "Inactive",
					"unconfirmed": "Unconfirmed",
					"pending": "Pending",
					"review": "Needs revision",
					"pre_review": "Pre Revision",
					"statuses": {
						"active": "Active",
						"confirmed": "Confirmed",
						"inactive": "Inactive",
						"unconfirmed": "Unconfirmed",
						"pending": "Pending"
					}
				}
			},
			"workflow": {
				"id": "ID",
				"name": "Name",
				"status": "Status",
				"last_execution": "Last execution",
				"frequency": "Frequency",
				"first_run": "First run (UTC)",
				"final_run": "Final run (UTC)",
				"daily_runtime": "Daily runtime (UTC)",
				"action": "Action",
				"project": "Project",
				"project_name": "Project",
				"execute_on": "Condition",
				"configuration": "Configuration",
				"scope": "Retrieve leads from:",
				"loading_projects": "Loading projects…",
				"message": {
					"create": "Workflow successfully created",
					"trigger_success": "Workflow successfully triggered",
					"update": "Workflow successfully updated"
				},
				"collection": {
					"frequency": {
						"daily": "Daily",
						"immediately": "Hourly",
						"once": "Once",
						"undefined": "–"
					}
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/hileadzz/models.yml
// module id = 2029
// module chunks = 0